import type { CatalogEntry, VoltageClass } from '../types/catalog';
import type { Vendor } from '../types/drive';

export interface CatalogFilter {
  vendor?: Vendor;
  voltageClass?: VoltageClass;
  family?: string;
  search?: string;
  powerMin?: number;
  powerMax?: number;
}

export function applyCatalogFilter(models: CatalogEntry[], filter: CatalogFilter): CatalogEntry[] {
  let results = [...models];

  if (filter.vendor) {
    results = results.filter(m => m.vendor === filter.vendor);
  }
  if (filter.voltageClass) {
    results = results.filter(m => m.voltageClass === filter.voltageClass);
  }
  if (filter.family) {
    results = results.filter(m => m.family.toLowerCase() === filter.family!.toLowerCase());
  }
  if (filter.search) {
    const q = filter.search.toLowerCase();
    results = results.filter(m =>
      m.modelCode.toLowerCase().includes(q) ||
      m.name.toLowerCase().includes(q) ||
      m.family.toLowerCase().includes(q)
    );
  }
  if (filter.powerMin !== undefined) {
    results = results.filter(m => m.powerKW >= filter.powerMin!);
  }
  if (filter.powerMax !== undefined) {
    results = results.filter(m => m.powerKW <= filter.powerMax!);
  }

  return results;
}